import type { PaletteOptions } from '@mui/material/styles';

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: { main: '#1F3C6E' },
  secondary: { main: '#00A876' },
  error: { main: '#D50000' },
  warning: { main: '#DC7D00' },
  success: { main: '#039112' },
  action: { disabled: '#999999' },
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: { main: '#89CEE3' },
  secondary: { main: '#00A876' },
  error: { main: '#F2B3B3' },
  warning: { main: '#DC7D00' },
  success: { main: '#039112' },
  action: { disabled: '#999999' },
};
